import {createDocumentResource, createQueryResource, getResourceService, list, receiveData} from 'retil';
import axios from 'axios';
import { toSafeInteger } from '@2023-contest-web/components/src/utils';
import { BaseURL, ContestToken, isMock } from './config';
import {Onlive} from "@2023-contest-web/components/src/types";

export const onlive = createDocumentResource<Onlive>('onlive');
export const onliveList = createQueryResource('onliveList', {
    for: list(onlive),
    load: async () => {
        if (isMock()) {
            return [];
        }
        try {
            const res = await axios.get(`https://hauptmann.age.co.jp/api/onlive2023.json`, {
                headers: {
                    'content-type': 'application/json',
                    'x-access-token': '39104a9d4794852d6e9bb09e66b136d7ed17f12b',
                },
            });
            return res.data.result.response
                .map((onlive: any) => {
                    const [, numberText] = onlive.roomUrl.split('_');
                    const entry_id = toSafeInteger(numberText);
                    if (entry_id < 1) {
                        return null;
                    }
                    return { ...onlive, entry_id, id: entry_id };
                })
                .filter((onlive: any) => !!onlive);
        } catch {
            return [];
        }
    },
});

// NOTE:- Create Initial State

const [, controller] = getResourceService(onliveList);

// InitialState
receiveData(onliveList, {
    data: [],
});

controller.invalidate();